<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <ProductForm v-model="product" title="Editace produktu" :loading="saving" @save="save" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions } from 'vuex'
import ProductForm from '../../../components/product/ProductForm'

export default {
  name: 'SupplierProductEdit',
  components: {
    ProductForm,
  },
  data() {
    return {
      product: {},
      productLoading: null,
      saving: false,
    }
  },
  created() {
    this.loadProduct()
  },
  methods: {
    ...mapActions({
      getSupplierProduct: 'supplier/getSupplierProduct',
      updateSupplierProduct: 'supplier/updateSupplierProduct',
    }),
    loadProduct() {
      this.productLoading = true
      this.getSupplierProduct({
        supplierId: this.$route.params.supplierId,
        productId: this.$route.params.productId,
        type: this.$route.params.type,
      })
        .then((response) => {
          this.product = response.data
        })
        .finally(() => {
          this.productLoading = false
        })
    },
    save() {
      this.saving = true
      this.updateSupplierProduct({
        supplierId: this.$route.params.supplierId,
        productId: this.$route.params.productId,
        type: this.$route.params.type,
        product: this.product,
      })
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$router.back()
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
